import { render } from "./PainelNoticias.vue?vue&type=template&id=cde6394c&scoped=true"
import script from "./PainelNoticias.vue?vue&type=script&lang=js"
export * from "./PainelNoticias.vue?vue&type=script&lang=js"

import "./PainelNoticias.vue?vue&type=style&index=0&id=cde6394c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde6394c"]])

export default __exports__